import { graphql } from "./__generated__/gql";

export const UPDATE_EVENT_MUTATION = graphql(`
  mutation UpdateEvent($id: UUID!, $set: eventUpdateInput!) {
    updateeventCollection(filter: { id: { eq: $id } }, set: $set) {
      affectedCount
    }
  }
`);

export const REPLACE_TICKET_KIND_MUTATION = graphql(`
  mutation ReplaceTicketKind(
    $eventId: UUID!
    $newTicket: event_ticket_kindInsertInput!
  ) {
    updateevent_ticket_kindCollection(
      filter: { event_id: { eq: $eventId }, status: { neq: "hidden" } }
      set: { status: "hidden" }
      atMost: 3
    ) {
      affectedCount
    }
    insertIntoevent_ticket_kindCollection(objects: [$newTicket]) {
      records {
        id
      }
    }
  }
`);
